<template>
  <div class="LayoutArticle">
    <!-- <IndexHeader> </IndexHeader> -->
    <!-- <PageHeader> </PageHeader> -->
    <div class="main layout-main">
      <keep-alive :include="['xinxigongkai', 'NewsCategory', 'NewsDetail']">
        <router-view />
      </keep-alive>
    </div>
    <!-- <PageFooter> </PageFooter>
    <FixedLeft> </FixedLeft>
    <FixedRight> </FixedRight>
  --></div>
</template>
<script>
export default {
  name: "LayoutArticle",
  components: {},
};
</script>

<style lang="scss" scoped>
.LayoutArticle {
  // background: url("~@/assets/images/bg.png") no-repeat top center;
  overflow: hidden;
}
</style>
